module.exports = __webpack_public_path__ + "img/cnx.4d3c68eb.svg";